import { render, staticRenderFns } from "./PasoDosComponent.vue?vue&type=template&id=52e68e70&scoped=true"
import script from "./PasoDosComponent.vue?vue&type=script&lang=js"
export * from "./PasoDosComponent.vue?vue&type=script&lang=js"
import style0 from "./PasoDosComponent.vue?vue&type=style&index=0&id=52e68e70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e68e70",
  null
  
)

export default component.exports